(() => {
  'use strict';

  const currency = window.molloCurrency || 'EUR';

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency
        }
      ).format(Number(cents || 0) / 100);
    } catch (error) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  };


  /* =========================================================
     MOLLO — DRAWER REMOVE BUTTON STYLE
     ========================================================= */

  if (!document.getElementById('MolloDrawerRemoveStyle')) {
    const style = document.createElement('style');
    style.id = 'MolloDrawerRemoveStyle';

    style.textContent = `
      [data-cart-drawer] .mollo-drawer-removable {
        position: relative !important;
        padding-right: 48px !important;
      }

      [data-cart-drawer] .mollo-drawer-remove {
        appearance: none;
        position: absolute;
        right: 2px;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: 1px solid rgba(111, 135, 151, .28);
        border-radius: 50%;
        background: rgba(111, 135, 151, .08);
        color: #6F8797;
        cursor: pointer;
        transition:
          background .25s ease,
          border-color .25s ease,
          color .25s ease,
          transform .25s ease,
          opacity .2s ease;
        z-index: 2;
      }

      [data-cart-drawer] .mollo-drawer-remove svg {
        width: 17px;
        height: 17px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.45;
        stroke-linecap: round;
        stroke-linejoin: round;
        pointer-events: none;
      }

      [data-cart-drawer] .mollo-drawer-remove:hover {
        background: #6F8797;
        border-color: #6F8797;
        color: #ffffff;
        transform: translateY(-50%) scale(1.04);
      }

      [data-cart-drawer] .mollo-drawer-remove:focus-visible {
        outline: 2px solid #6F8797;
        outline-offset: 3px;
      }

      [data-cart-drawer] .mollo-drawer-remove.is-removing {
        opacity: .42;
        pointer-events: none;
      }

      [data-cart-drawer] .mollo-drawer-removable.is-removing {
        opacity: .42;
        transition: opacity .22s ease;
      }

      @media (max-width: 749px) {
        [data-cart-drawer] .mollo-drawer-removable {
          padding-right: 46px !important;
        }

        [data-cart-drawer] .mollo-drawer-remove {
          width: 40px;
          height: 40px;
          right: 0;
        }

        [data-cart-drawer] .mollo-drawer-remove svg {
          width: 16px;
          height: 16px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        [data-cart-drawer] .mollo-drawer-remove,
        [data-cart-drawer] .mollo-drawer-removable {
          transition: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }


  /* =========================================================
     PRODUCT MEDIA
     ========================================================= */

  const activateMedia = (gallery, mediaId) => {
    gallery.querySelectorAll('[data-mollo-media-panel]').forEach((panel) => {
      const active =
        String(panel.dataset.molloMediaPanel) === String(mediaId);

      panel.hidden = !active;
      panel.classList.toggle('is-active', active);

      if (!active) {
        panel
          .querySelectorAll('video')
          .forEach((video) => video.pause());
      }
    });

    gallery.querySelectorAll('[data-mollo-media-target]').forEach((thumb) => {
      const active =
        String(thumb.dataset.molloMediaTarget) === String(mediaId);

      thumb.classList.toggle('active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };


  document
    .querySelectorAll('[data-mollo-gallery]')
    .forEach((gallery) => {
      gallery
        .querySelectorAll('[data-mollo-media-target]')
        .forEach((thumb) => {
          thumb.addEventListener('click', () => {
            activateMedia(
              gallery,
              thumb.dataset.molloMediaTarget
            );
          });
        });
    });


  /* =========================================================
     QUANTITY SELECTOR
     ========================================================= */

  document
    .querySelectorAll('[data-quantity-selector]')
    .forEach((selector) => {
      const input =
        selector.querySelector('[data-quantity-input]');

      selector
        .querySelectorAll('[data-quantity-change]')
        .forEach((button) => {
          button.addEventListener('click', () => {
            const next = Math.max(
              Number(input.min || 1),
              Number(input.value || 1) +
                Number(button.dataset.quantityChange || 0)
            );

            input.value = String(next);

            input.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          });
        });
    });


  /* =========================================================
     BEFORE / AFTER
     ========================================================= */

  document
    .querySelectorAll('[data-before-after]')
    .forEach((comparison) => {
      comparison
        .querySelector('[data-before-after-range]')
        ?.addEventListener('input', (event) => {
          comparison.style.setProperty(
            '--ba-position',
            `${event.target.value}%`
          );
        });
    });


  /* =========================================================
     PRODUCT ROOT
     ========================================================= */

  document
    .querySelectorAll('[data-mollo-product]')
    .forEach((productRoot) => {
      const primaryButton =
        productRoot.querySelector('[data-add-to-cart]');

      const mobileBar =
        productRoot.querySelector('[data-mobile-buybar]');

      if (
        primaryButton &&
        mobileBar &&
        'IntersectionObserver' in window
      ) {
        const observer =
          new IntersectionObserver(
            ([entry]) => {
              mobileBar.classList.toggle(
                'is-visible',
                !entry.isIntersecting
              );
            },
            {
              threshold: .2
            }
          );

        observer.observe(primaryButton);
      }


      productRoot.addEventListener(
        'mollo:variant-change',
        (event) => {
          const variant = event.detail.variant;

          const compare =
            productRoot.querySelector('[data-compare-price]');

          const saving =
            productRoot.querySelector('[data-product-saving]');

          const saleBadge =
            productRoot.querySelector('[data-sale-badge]');

          const mobilePrice =
            productRoot.querySelector('[data-mobile-price]');

          const mobileAdd =
            productRoot.querySelector('[data-mobile-add]');

          const isSale =
            Number(variant.compare_at_price || 0) >
            Number(variant.price || 0);

          const percentage =
            isSale
              ? Math.round(
                  (
                    variant.compare_at_price -
                    variant.price
                  ) *
                    100 /
                    variant.compare_at_price
                )
              : 0;


          if (compare) {
            compare.hidden = !isSale;
            compare.textContent =
              isSale
                ? formatMoney(variant.compare_at_price)
                : '';
          }

          if (saving) {
            saving.hidden = !isSale;
            saving.textContent =
              isSale
                ? `Save ${percentage}%`
                : '';
          }

          if (saleBadge) {
            saleBadge.hidden = !isSale;
            saleBadge.textContent =
              `Save ${percentage}%`;
          }

          if (mobilePrice) {
            mobilePrice.textContent =
              formatMoney(variant.price);
          }

          if (mobileAdd) {
            mobileAdd.disabled =
              !variant.available;

            mobileAdd.textContent =
              variant.available
                ? 'Add to bag'
                : 'Sold out';
          }


          const mediaId =
            variant.featured_media &&
            variant.featured_media.id;

          const gallery =
            productRoot.querySelector('[data-mollo-gallery]');

          if (gallery && mediaId) {
            activateMedia(gallery, mediaId);
          }
        }
      );
    });


  /* =========================================================
     DYNAMIC CONTROLS
     ========================================================= */

  const bindDynamicControls = (scope) => {
    scope
      .querySelectorAll('[data-carousel]')
      .forEach((button) => {
        if (button.dataset.molloBound) return;

        button.dataset.molloBound = 'true';

        button.addEventListener('click', () => {
          const rail =
            document.getElementById(
              button.dataset.carousel
            );

          rail?.scrollBy({
            left:
              Number(button.dataset.direction || 1) *
              Math.min(rail.clientWidth * .82, 520),

            behavior: 'smooth'
          });
        });
      });


    scope
      .querySelectorAll('[data-quick-add]')
      .forEach((button) => {
        if (button.dataset.molloBound) return;

        button.dataset.molloBound = 'true';

        button.addEventListener('click', async () => {
          button.disabled = true;

          try {
            const root =
              (
                window.Shopify &&
                window.Shopify.routes &&
                window.Shopify.routes.root
              ) || '/';

            const response =
              await fetch(
                `${root}cart/add.js`,
                {
                  method: 'POST',

                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  },

                  body:
                    JSON.stringify({
                      items: [
                        {
                          id:
                            Number(
                              button.dataset.quickAdd
                            ),

                          quantity: 1
                        }
                      ]
                    })
                }
              );

            if (!response.ok) {
              throw new Error();
            }

            document
              .querySelector('[data-cart-open]')
              ?.click();

          } catch (error) {
            window.location.href =
              button
                .closest('.product-card')
                ?.querySelector('a')
                ?.href
              ||
              '/collections/all';

          } finally {
            button.disabled = false;
          }
        });
      });
  };


  /* =========================================================
     RECOMMENDATIONS
     ========================================================= */

  const loadRecommendations =
    async (section) => {
      if (
        !section.dataset.productId ||
        !section.dataset.recommendationsUrl ||
        section.dataset.loaded
      ) {
        return;
      }

      section.dataset.loaded = 'true';

      const parameters =
        new URLSearchParams({
          section_id:
            section.dataset.sectionId,

          product_id:
            section.dataset.productId,

          limit:
            section.dataset.limit || '4',

          intent:
            'related'
        });


      try {
        const response =
          await fetch(
            `${section.dataset.recommendationsUrl}?${parameters}`
          );

        if (!response.ok) return;

        const html =
          document.createElement('div');

        html.innerHTML =
          await response.text();

        const replacement =
          html.querySelector(
            '[data-mollo-recommendations]'
          );

        if (
          replacement &&
          !replacement.classList.contains('is-pending') &&
          replacement.innerHTML.trim()
        ) {
          section.innerHTML =
            replacement.innerHTML;

          section.classList.remove('is-pending');

          bindDynamicControls(section);

          section
            .querySelectorAll('.reveal')
            .forEach((element) => {
              element.classList.add('visible');
            });
        }

      } catch (error) {
        /* Recommendations are optional. */
      }
    };


  document
    .querySelectorAll('[data-mollo-recommendations]')
    .forEach(loadRecommendations);


  /* =========================================================
     CART DRAWER
     ========================================================= */

  const drawer =
    document.querySelector('[data-cart-drawer]');

  const progress =
    drawer?.querySelector('[data-drawer-progress]');

  const cartItemsRoot =
    drawer?.querySelector('[data-cart-items]');


  const getRoot = () =>
    (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';


  const fetchCart = async () => {
    const response =
      await fetch(
        `${getRoot()}cart.js`,
        {
          headers: {
            Accept: 'application/json'
          },

          credentials: 'same-origin'
        }
      );

    if (!response.ok) {
      throw new Error(
        'Unable to read cart.'
      );
    }

    return response.json();
  };


  const updateDrawerProgressFromCart =
    (cart) => {
      if (!progress || !cart) return;

      const threshold = 20000;

      const remaining =
        Math.max(
          0,
          threshold - cart.total_price
        );


      const text =
        progress.querySelector('p');

      const bar =
        progress.querySelector('span');


      if (text) {
        text.innerHTML =
          remaining > 0
            ? `Add <strong>${formatMoney(remaining)}</strong> for complimentary tracked delivery.`
            : '<strong>Complimentary tracked delivery unlocked.</strong>';
      }


      if (bar) {
        bar.style.width =
          `${Math.min(
            100,
            cart.total_price * 100 / threshold
          )}%`;
      }
    };


  const updateGlobalCartCount =
    (cart) => {
      if (!cart) return;

      document
        .querySelectorAll('[data-cart-count]')
        .forEach((count) => {
          count.textContent =
            String(cart.item_count);
        });
    };


  const updateDrawerSubtotal =
    (cart) => {
      if (!drawer || !cart) return;

      const possibleSubtotal =
        drawer.querySelector(
          [
            '[data-cart-subtotal]',
            '[data-drawer-subtotal]',
            '.cart-drawer-subtotal strong',
            '.drawer-subtotal strong',
            '.mollo-cart-drawer-subtotal strong'
          ].join(',')
        );

      if (possibleSubtotal) {
        possibleSubtotal.textContent =
          formatMoney(cart.total_price);
      }
    };


  const productPath =
    (value) => {
      try {
        return new URL(
          value,
          window.location.origin
        ).pathname;
      } catch (error) {
        return String(value || '')
          .split('?')[0];
      }
    };


  /*
   * Find the DOM element corresponding to one Shopify cart item.
   * We use its product URL, so the code works even if your drawer
   * does not currently have data-cart-item attributes.
   */
  const findDrawerRowForItem =
    (item) => {
      if (!cartItemsRoot || !item) return null;

      const wanted =
        productPath(item.url);


      const links =
        Array.from(
          cartItemsRoot.querySelectorAll('a[href]')
        );


      const productLinks =
        links.filter((link) => {
          return (
            productPath(link.href) === wanted
          );
        });


      if (!productLinks.length) {
        return null;
      }


      /*
       * Prefer the product image link if present.
       */
      let anchor =
        productLinks.find((link) => {
          return Boolean(
            link.querySelector('img')
          );
        })
        ||
        productLinks[0];


      let row = anchor;


      while (
        row.parentElement &&
        row.parentElement !== cartItemsRoot
      ) {
        const parent =
          row.parentElement;


        const distinctProducts =
          new Set(
            Array.from(
              parent.querySelectorAll(
                'a[href*="/products/"]'
              )
            ).map((link) =>
              productPath(link.href)
            )
          );


        /*
         * Stop climbing as soon as the parent starts
         * containing multiple different cart products.
         */
        if (distinctProducts.size > 1) {
          break;
        }


        row = parent;
      }


      return row;
    };


  const trashIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 7h16"></path>
      <path d="M9 7V4h6v3"></path>
      <path d="M7 7l1 13h8l1-13"></path>
      <path d="M10 11v5"></path>
      <path d="M14 11v5"></path>
    </svg>
  `;


  let enhancingDrawer = false;


  const enhanceDrawerRemoveButtons =
    async () => {
      if (
        !drawer ||
        !cartItemsRoot ||
        enhancingDrawer
      ) {
        return;
      }


      enhancingDrawer = true;


      try {
        const cart =
          await fetchCart();


        cart.items.forEach((item) => {
          const row =
            findDrawerRowForItem(item);


          if (!row) return;


          row.classList.add(
            'mollo-drawer-removable'
          );


          /*
           * Do not create the same button twice.
           */
          if (
            row.querySelector(
              `.mollo-drawer-remove[data-line-key="${CSS.escape(item.key)}"]`
            )
          ) {
            return;
          }


          const button =
            document.createElement('button');


          button.type =
            'button';


          button.className =
            'mollo-drawer-remove';


          button.dataset.lineKey =
            item.key;


          button.setAttribute(
            'aria-label',
            `Remove ${item.product_title || item.title || 'item'} from bag`
          );


          button.innerHTML =
            trashIcon;


          button.addEventListener(
            'click',
            async (event) => {
              event.preventDefault();
              event.stopPropagation();


              if (
                button.classList.contains(
                  'is-removing'
                )
              ) {
                return;
              }


              button.classList.add(
                'is-removing'
              );


              row.classList.add(
                'is-removing'
              );


              try {
                const response =
                  await fetch(
                    `${getRoot()}cart/change.js`,
                    {
                      method: 'POST',

                      headers: {
                        'Content-Type':
                          'application/json',

                        Accept:
                          'application/json'
                      },

                      credentials:
                        'same-origin',

                      body:
                        JSON.stringify({
                          id:
                            item.key,

                          quantity:
                            0
                        })
                    }
                  );


                if (!response.ok) {
                  throw new Error(
                    'Unable to remove item.'
                  );
                }


                const updatedCart =
                  await response.json();


                /*
                 * Remove the line visually straight away.
                 */
                row.remove();


                updateGlobalCartCount(
                  updatedCart
                );


                updateDrawerProgressFromCart(
                  updatedCart
                );


                updateDrawerSubtotal(
                  updatedCart
                );


                document.dispatchEvent(
                  new CustomEvent(
                    'cart:updated',
                    {
                      detail: {
                        cart:
                          updatedCart
                      }
                    }
                  )
                );


                document.dispatchEvent(
                  new CustomEvent(
                    'mollo:cart:updated',
                    {
                      detail: {
                        cart:
                          updatedCart
                      }
                    }
                  )
                );


                /*
                 * If the bag becomes empty, refresh once so your
                 * theme can display its own empty-cart drawer state.
                 */
                if (
                  updatedCart.item_count === 0
                ) {
                  window.setTimeout(
                    () => {
                      window.location.reload();
                    },
                    180
                  );

                  return;
                }


                /*
                 * Re-map the remaining DOM rows to their new cart state.
                 */
                window.setTimeout(
                  enhanceDrawerRemoveButtons,
                  80
                );

              } catch (error) {
                console.error(
                  '[MOLLO] Drawer remove error:',
                  error
                );


                button.classList.remove(
                  'is-removing'
                );


                row.classList.remove(
                  'is-removing'
                );
              }
            }
          );


          row.appendChild(button);
        });


        updateGlobalCartCount(cart);
        updateDrawerProgressFromCart(cart);
        updateDrawerSubtotal(cart);

      } catch (error) {
        console.warn(
          '[MOLLO] Drawer enhancement skipped:',
          error
        );

      } finally {
        enhancingDrawer = false;
      }
    };


  if (
    drawer &&
    progress
  ) {
    const updateDrawerProgress =
      async () => {
        try {
          const cart =
            await fetchCart();

          updateDrawerProgressFromCart(
            cart
          );

          updateGlobalCartCount(
            cart
          );

          updateDrawerSubtotal(
            cart
          );

        } catch (error) {
          /* The cart remains fully usable. */
        }
      };


    if (cartItemsRoot) {
      const observer =
        new MutationObserver(() => {
          updateDrawerProgress();
          enhanceDrawerRemoveButtons();
        });


      observer.observe(
        cartItemsRoot,
        {
          childList: true,
          subtree: true
        }
      );
    }


    updateDrawerProgress();
    enhanceDrawerRemoveButtons();
  }


  /*
   * When the drawer is opened, ensure the icons are present.
   */
  document
    .querySelectorAll('[data-cart-open]')
    .forEach((openButton) => {
      openButton.addEventListener(
        'click',
        () => {
          window.setTimeout(
            enhanceDrawerRemoveButtons,
            180
          );
        }
      );
    });


  /*
   * If another MOLLO script refreshes the cart,
   * remap the trash icons.
   */
  document.addEventListener(
    'cart:updated',
    () => {
      window.setTimeout(
        enhanceDrawerRemoveButtons,
        80
      );
    }
  );


  document.addEventListener(
    'mollo:cart:updated',
    () => {
      window.setTimeout(
        enhanceDrawerRemoveButtons,
        80
      );
    }
  );

})();
